module.exports = __webpack_public_path__ + "static/media/sudeep_s.67797e13.jpeg";